
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/moleskine",
      function () {
        return require("private-next-pages/locale/moleskine.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/moleskine"])
      });
    }
  